import React from 'react';
import {horFPLogo} from '../images/horizontalLogoURL';


export default ({width="auto", height="auto", style={}}) => {
  return <img style={style} width={width} height={height} src={horFPLogo} />
}
